/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class RoleApi {
    static getInstance() {
        if (!this.instance) this.instance = new RoleApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 角色列表
    async getRoleList (param,page_num,page_size){
        let url = `/api/sys/role/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增角色 
    async addRole (param){
        let url = `/api/sys/role`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 修改角色 
    async editRole (param,id){
        let url = `/api/sys/role/${id}`
        let result = await this.getData(url,param,'PATCH')
        return result
    }

    // 删除角色 
    async deleteRole (id){
        let url = `/api/sys/role/delete/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 新增用户绑定角色 
    async addUserBindRole (param){
        let url = `/api/sys/role/user/add`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 用户绑定的角色列表
    async getUserRole (param, user_id){
        let url = `/api/sys/role/${user_id}/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 角色关联菜单
    async addRoleMenu (param){
        let url = `/api/sys/role/menus`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 查询角色关联的菜单列表
    // async getRoleMenu(param, role_id){
    //     let url = `/api/sys/menu/role/${role_id}`
    //     let result = await this.getData(url,param,'POST')
    //     return result
    // }   

    // 查询用户关联的菜单列表 
    async getUserMenu (param, user_id, tenant_id){
        let url = `/api/sys/menu/user/${user_id}?tenant_id=${tenant_id}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 查询租户列表
    async getTenantList (){
        let url = `/api/sys/tenant/dropdown/query`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 查询租户列表
    async getTenantList2 (param){
        let url = `/api/sys/tenant/dropdown/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 角色父级树状列表
    async getRoleParentTree (param, user_id){
        let url = `/api/sys/role/tree/${user_id}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取当前用户是否能分配角色权限
    async getUserHasAssignRoleAuth (param, user_id){
        let url = `/api/sys/role/issued/${user_id}`
        let result = await this.getData(url,param,'POST')
        return result
    }
    
     // 查询用户租户下的角色列表
     async getTenantRoleList (param, user_id){
        let url = `/api/sys/role/user/${user_id}`
        let result = await this.getData(url,param,'POST')
        return result
    }
    
}

export {
    RoleApi
}